<div class="operation-overview-container" style="max-width: 1000px;">
  <span class="air-heading">Operations Overview</span>

  <div class="tlr-table-container">
    <!-- Loading indicator -->
    

    <p-table
      styleClass="p-datatable-gridlines"
      [value]="tlrItems"
      id="StyleTable"
      [rowHover]="true"
      *ngIf="tlrItems.length > 0"
      [frozenWidth]="'500px'"
      >
      <ng-template pTemplate="header">
        <tr>
          <th class="tlr-id-header">My TLR's</th>
          <th class="status-header">TLR Status</th>
          <th class="action-header"></th>
          <th class="action-header"></th>
           <th class="action-header"></th>
            <th class="action-header"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr>
          <td class="tlr-id">{{ item.id }}</td>
          <td
            class="tlr-status"
            [ngClass]="{ 'removed-status': item.status === 'Removed', 'blue': item.status === 'Pre-Installation', 'green': item.status === 'Installed' }"
          >
            {{ item.status }}
          </td>
          <td class="details-cell">
            <a class="link-underline" (click)="onDetailsClick(item.id)"
              >Details</a
            >
          </td>
          <td class="details-cell">
            <a class="link-underline" (click)="onEditClick(item.id)"
               *ngIf="item.status === 'Installed'">Edit</a
            >
          </td>
          <td class="details-cell">
            <a class="link-underline" (click)="onRepumpClick(item.id)"
               *ngIf="item.status === 'Installed'">Repump</a
            >
          </td>
          <td class="delete-cell">
            <a class="delete-link" (click)="onDeleteClick(item.id)">Delete</a>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="4" class="empty-message">No TLR data found.</td>
        </tr>
      </ng-template>
    </p-table>

    <p *ngIf="tlrItems.length == 0" class="MessageTitle">
      You do not have any TLR's
    </p>
  </div>
</div>
